import styled from 'styled-components';

export const ErrorWarning = styled.p`
    color: red;
    marginTop: 3;
    fontSize: 14;
`;
